
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'Slider',
  props: {
    modelValue: [Number, String],
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    labelLeft: String,
    labelRight: String,
  },
  setup(props, { emit }) {
    const value = computed({
      get: () => Number(props.modelValue),
      set: (v) => emit('update:modelValue', v),
    });

    const percent = computed(() => `${((+value.value - props.min) / (props.max - props.min)) * 100}%`);

    return {
      value,
      percent,
    };
  },
});
